import Popup from './popup';
import { EnhanceEcommerce } from '../../helpers/EnhanceEcommerce';
import { getUrlParams } from '../../helpers/handle-url';
import { GA4SampleOrderTracker } from '../GA4/GA4SampleOrderTracker';
import PageTypes from '../../helpers/page-types';

const BuySamplePopup = Popup.extend({
	constructor(options) {
		this.config = {
			opener: '.is-buy-sample-popup-button',
			popupContent: '#buy-sample',
			buyBtn: '.buy-btn',
			priceSelect: '.prices-select .customized',
			priceForSample: '[data-quantity="1"]',
			confiBtn: '.js-personalize-button',
			popup: '.modal-window',
			content: '.modal-content',
			overlay: '.modal-window-overlay',
			closeBtn: '.modal-window .close-btn',
			sentDirectToConfigurator: {
				categories: 'Hochzeitseinladung,',
				ignoreProducts: 'Glanzvoll,',
			}, // Introduce as a test for ticket WEDS-1996 and extended by WEDS-2410
			className: 'free-sample-modal',
		};

		jQuery.extend(true, this.config, options || {});

		this.init();

		this.attachEvents();

		this.popupContent = jQuery(jQuery(this.config.popupContent).html());
	},

	attachEvents() {
		jQuery(document)
			.on('click', this.config.opener, (e) => {
				e.preventDefault();

				jQuery(this.config.priceSelect).trigger('click').find(this.config.priceForSample).trigger('click');

				const { categories, ignoreProducts } = this.config.sentDirectToConfigurator;

				if (
					productJSON &&
					~categories.indexOf(productJSON.groupName) &&
					!~ignoreProducts.indexOf(productJSON.name)
				) {
					this.sendToConfigurator();

					return;
				}

				if (this.config.priceCalculator) {
					this.popupContent.find('.sample-price').html(this.config.priceCalculator.getSamplePrice());
				}

				this.open(this.popupContent);
			})
			.on(
				'click',
				this.config.buyBtn,
				jQuery.proxy(function (e) {
					e.preventDefault();

					this.close();

					this.sendToConfigurator();
				}, this)
			);
	},

	sendToConfigurator() {
		const element = jQuery(this.config.confiBtn);
		const url = element.attr('data-href');
		const customOptions = getUrlParams();
		const eventType = element.hasClass('no-confi') ? 'eec-add-to-basket' : 'eec-open-configurator';

		const sampleOrderData = {
			cta_position: PageTypes.PDP,
			product_category: productJSON.groupName,
			custom_item_name: productJSON.name,
			custom_item_id: productJSON.abstractSku,
			custom_item_category: productJSON.primaryCategory ? productJSON.primaryCategory.identifier : '',
			custom_item_category_2: '',
			custom_item_category_3: '',
		};
		GA4SampleOrderTracker.trackSampleOrderCTA(sampleOrderData);

		EnhanceEcommerce.trackGoToConfigurator(productJSON, customOptions, eventType, url);
	},
});

export default BuySamplePopup;
